import * as Yup from 'yup';


export const formValidacion =[
    Yup.object().shape({
        // id_parent: Yup.number(),
        flujo: Yup.string(),
        tarea: Yup.string().required('No se ha ingresado título de tarea'),
        objetivo: Yup.string().required('Describa el objetivo de la tarea'),
        prioridad: Yup.string().required('Prioridad necesaria'),
        recordatorio: Yup.date().required('Campo requerido'),
        inicio_proyectado: Yup.date().required('Campo requerido'),
        termino_proyectado: Yup.date().required('Campo requerido'),
        id_estatus: Yup.number().required('Campo requerido'),
        creada_por: Yup.string().required(''),
        miembros:  Yup.array().min(1, 'Debe haber al menos un responsable').required('Debe haber al menos un responsable')
    }),
    Yup.object().shape({
        notas: Yup.string(),
    })
]

